import { EventData } from './../../../model/event';
import { ContentData } from './../../../model/content';
import { Component, Inject, OnInit } from '@angular/core';
import { Program } from '@app-model/program';
import { WellHub} from '@app-model/wellHub';
import { ContentsService } from '@app-services/content.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EventService } from '@app-services/event.service';
import { Router } from '@angular/router';
import { ProgramService } from '@app-services/program.service';
import { WellHubService} from '@app-services/wellHub.service';
import { BusinessPartnerService } from '@app-services/businessPartner.service';
import { Benefit } from '@app-model/benefit';
import { BenefitService } from '@app-services/benefit.service';
import { InformativeService } from '@app-services/informative.service';
import { BusinessPartner } from "@app-model/businessPartner";
import {Marketplace} from "@app-model/markeyplace";
import {MarketplaceService} from "@app-services/marketplace.service";
import { Course } from '@app-model/course';
@Component({
    selector: 'app-dialog-remove',
    templateUrl: './dialog-remove.component.html',
    styleUrls: ['./dialog-remove.component.scss'],
    standalone: false
})
export class DialogRemoveComponent implements OnInit {

  isLoading = false;
  hasBeenCanceled = false;
  event: EventData;
  tip: ContentData;
  informativeId: string;
  program: Program;
  wellHub: WellHub;
  course: Course.Entity;
  businessPartner: BusinessPartner;
  marketplace: Marketplace;
  benefit: Benefit;
  errorMessage: string;
  done = false;

  constructor(
    private eventService: EventService,
    private tipService: ContentsService,
    private informativeService: InformativeService,
    private programService: ProgramService,
    private wellHubService: WellHubService,
    private businessPartnerService: BusinessPartnerService,
    private marketplaceService: MarketplaceService,
    private benefitService: BenefitService,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<DialogRemoveComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private router: Router
  ) {}

  ngOnInit() {
    this.event = this.data.event;
    this.tip = this.data.tip;
    this.informativeId = this.data.informativeId;
    this.program = this.data.program;
    this.wellHub = this.data.wellHub;
    this.course = this.data.course;
    this.businessPartner = this.data.businessPartner;
    this.marketplace = this.data.marketplace;
    this.benefit = this.data.benefit;
    this.dialogRef.beforeClosed().subscribe((res) => {
      if(res?.shouldRemove){
        this.dialogRef.close({
          shouldRemove: true,
        })
        return;
      }
      this.dialogRef.close({ message: this.errorMessage })})
    };
  

  onRemoveEvent(event: EventData) {
    const removedEvent = event;

    this.eventService.removeEvent(removedEvent).subscribe(
    res => {
      if (res) {
        this.done = true;
        this.errorMessage = 'Evento removido com sucesso.';
      } else {
        this.errorMessage = 'Não foi possível remover este evento';
      }
    });
  }

  onRemoveTip(tip: ContentData) {
    const removedTip = tip;

    this.tipService.removeTip(removedTip).subscribe(
    res => {
      if (res) {
        this.done = true;
        this.errorMessage = 'Conteúdo removido com sucesso.';
      } else {
        this.errorMessage = 'Não foi possível remover este conteúdo';
      }
    });
  }

  onRemoveInformative(id: string) {
    this.informativeService.removeInformative(id)
    .subscribe(
      res => {
        if (res) {
          this.done = true;
          this.errorMessage = 'Informativo removido com sucesso.';
        } else {
          this.errorMessage = 'Não foi possível remover este informativo';
        }
      });
  }

  onRemoveProgram(program: Program) {
    const removedProgram = program;
    removedProgram.active = false;

    this.programService.removeProgram(removedProgram).subscribe((res) => {
      if (res) {
        this.done = true;
        this.errorMessage = 'Programa removido com sucesso.';
      } else {
        this.errorMessage = 'Não foi possível remover este programa';
      }
    });
  }

  onRemoveWellHub(wellHub: WellHub) {
    const removedWellHub = wellHub;
    removedWellHub.active = false;

    this.wellHubService.removeWellHub(removedWellHub).subscribe((res) => {
      if (res) {
        this.done = true;
        this.errorMessage = 'Wellhub removido com sucesso.';
      } else {
        this.errorMessage = 'Não foi possível remover este Wellhub';
      }
    });
  }

  onRemoveBusinessPartner(businessPartner: BusinessPartner) {
    const removedBusinessPartner = businessPartner;
    removedBusinessPartner.active = false;

    this.businessPartnerService.removeBusinessPartner(removedBusinessPartner).subscribe((res) => {
      if (res) {
        this.done = true;
        this.errorMessage = 'Parceiro removido com sucesso.';
      } else {
        this.errorMessage = 'Não foi possível remover este Parceiro';
      }
    });
  }

  onRemoveMarketplace(marketplace: Marketplace) {
    const removedMarketplace = marketplace;
    removedMarketplace.active = false;

    this.marketplaceService.removeMarketplace(removedMarketplace).subscribe((res) => {
      if (res) {
        this.done = true;
        this.errorMessage = 'Loja removida com sucesso.';
      } else {
        this.errorMessage = 'Não foi possível remover esta Loja';
      }
    });
  }

  onRemoveBenefit(benefit: Benefit) {
    const removedBenefit = benefit;
    removedBenefit.active = false;

    this.benefitService.removeBenefit(removedBenefit).subscribe((res) => {
      if (res) {
        this.done = true;
        this.errorMessage = 'Benefício removido com sucesso.';
      } else {
        this.errorMessage = 'Não foi possível remover este benefício';
      }
    });
  }
  onRemoveCourse() {
    this.dialogRef.close({ shouldRemove: true });
  }
}
